import { useState,useEffect } from "react";
import { useLocation } from 'react-router-dom';
function formatNumberWithCommasAndFontWeight(value) {
  const formattedValue = parseFloat(value).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const parts = formattedValue.split(".");
  const integerPart = parts[0];
  const decimalPart = parts[1];

  return (
    <span style={{ fontWeight: 700 }}>
      {integerPart}.<span style={{ fontWeight: 400 }}>{decimalPart}</span>
    </span>
  );
}
function notFloat(value) {
  return isNaN(parseFloat(value));
}
function calculatePivotPoints(high, low, open, close, setupdatedStocks) {
  if (notFloat(high) || notFloat(low) || notFloat(close)) {
    setupdatedStocks({
      pivot_levels: [
        {
          pivotlevel_name: "Classic",
          s3: "-",
          s2: "-",
          s1: "-",
          pp: "-",
          r1: "-",
          r2: "-",
          r3: "-",
        },
        {
          pivotlevel_name: "Woodie’s",
          s3: "-",
          s2: "-",
          s1: "-",
          pp: "-",
          r1: "-",
          r2: "-",
          r3: "-",
        },
        {
          pivotlevel_name: "Fibonacci",
          s3: "-",
          s2: "-",
          s1: "-",
          pp: "-",
          r1: "-",
          r2: "-",
          r3: "-",
        },
        {
          pivotlevel_name: "Camarilla",
          s3: "-",
          s2: "-",
          s1: "-",
          pp: "-",
          r1: "-",
          r2: "-",
          r3: "-",
        },
      ],
    });
    return;
  }
  const pivotlevel_stocks = [];

  const cpr_pivot = (high + low + close) / 3;
  const cpr_bp = (high + low) / 2;
  const cpr_tp = cpr_pivot - cpr_bp + cpr_pivot;

  const cpr_s1 = 2 * cpr_pivot - high;
  const cpr_s2 = cpr_pivot - (high - low);
  const cpr_s3 = low - 2 * (high - cpr_pivot);

  const cpr_r1 = 2 * cpr_pivot - low;
  const cpr_r2 = cpr_pivot + (high - low);
  const cpr_r3 = high + 2 * (cpr_pivot - low);
  pivotlevel_stocks.push({
    pivotlevel_name: "Classic",
    r3: cpr_r3,
    r2: cpr_r2,
    r1: cpr_r1,
    s3: cpr_s3,
    s2: cpr_s2,
    s1: cpr_s1,
    pp: cpr_pivot,
    bcp: cpr_bp,
    tcp: cpr_tp,
  });

  // Woodie's Pivots Computation
  const range = high - low;
  const woodies_pivot = (high + low + open * 2) / 4;
  const woodies_s1 = 2 * woodies_pivot - high;
  const woodies_s2 = woodies_pivot - range;
  const woodies_s3 = low - 2 * (high - woodies_pivot);
  const woodies_r1 = 2 * woodies_pivot - low;
  const woodies_r2 = woodies_pivot + range;
  const woodies_r3 = high + 2 * (woodies_pivot - low);

  pivotlevel_stocks.push({
    pivotlevel_name: "Woodie's",
    r3: woodies_r3,
    r2: woodies_r2,
    r1: woodies_r1,
    s3: woodies_s3,
    s2: woodies_s2,
    s1: woodies_s1,
    pp: woodies_pivot,
  });

  // Fibonacci Pivots Computation
  const fibonnaci_pivot = cpr_pivot;
  const fibonnaci_s1 = fibonnaci_pivot - 0.382 * (high - low);
  const fibonnaci_s2 = fibonnaci_pivot - 0.618 * (high - low);
  const fibonnaci_s3 = fibonnaci_pivot - (high - low);
  const fibonnaci_r1 = fibonnaci_pivot + 0.382 * (high - low);
  const fibonnaci_r2 = fibonnaci_pivot + 0.618 * (high - low);
  const fibonnaci_r3 = fibonnaci_pivot + (high - low);

  pivotlevel_stocks.push({
    pivotlevel_name: "Fibonacci",
    r3: fibonnaci_r3,
    r2: fibonnaci_r2,
    r1: fibonnaci_r1,
    s3: fibonnaci_s3,
    s2: fibonnaci_s2,
    s1: fibonnaci_s1,
    pp: fibonnaci_pivot,
  });

  // Camarilla Pivots Computation
  const camarilla_pivot = cpr_pivot;
  const camarilla_s1 = close - (high - low) * 1.0833;
  const camarilla_s2 = close - (high - low) * 1.1666;
  const camarilla_s3 = close - (high - low) * 1.25;
  const camarilla_r1 = close + (high - low) * 1.0833;
  const camarilla_r2 = close + (high - low) * 1.1666;
  const camarilla_r3 = close + (high - low) * 1.25;

  pivotlevel_stocks.push({
    pivotlevel_name: "Camarilla",
    r3: camarilla_r3,
    r2: camarilla_r2,
    r1: camarilla_r1,
    s3: camarilla_s3,
    s2: camarilla_s2,
    s1: camarilla_s1,
    pp: camarilla_pivot,
  });
  console.log(pivotlevel_stocks);
  setupdatedStocks({ pivot_levels: pivotlevel_stocks });
}

export default function PivotPointscal() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const theme = params.get('theme');
  console.log(theme)
  useEffect(() => {
    if (theme) {
      document.documentElement.setAttribute('data-theme', theme);
    }
  }, [theme]);
  const [Close, setClose] = useState(null);
  const [Open, setOpen] = useState(null);
  const [High, setHigh] = useState(null);
  const [Low, setLow] = useState(null);
  const [updatedStocks, setupdatedStocks] = useState({
    pivot_levels: [
      {
        pivotlevel_name: "Classic",
        s3: "-",
        s2: "-",
        s1: "-",
        pp: "-",
        r1: "-",
        r2: "-",
        r3: "-",
      },
      {
        pivotlevel_name: "Woodie’s",
        s3: "-",
        s2: "-",
        s1: "-",
        pp: "-",
        r1: "-",
        r2: "-",
        r3: "-",
      },
      {
        pivotlevel_name: "Fibonacci",
        s3: "-",
        s2: "-",
        s1: "-",
        pp: "-",
        r1: "-",
        r2: "-",
        r3: "-",
      },
      {
        pivotlevel_name: "Camarilla",
        s3: "-",
        s2: "-",
        s1: "-",
        pp: "-",
        r1: "-",
        r2: "-",
        r3: "-",
      },
    ],
  });

  const items = ["Open", "High", "Low", "Close"];
  console.log(updatedStocks);
  return (
    <div className="fullOuterpiv flex flex-col justify-center">
      <label className="main-headding">Pivot points calculator</label>
      <label className="scndrylbl">
        Classic, Fibonacci, Camarilla, Woodie’s calculators
      </label>
      <div className="wholecomppivot zoom-out-80 ">
        <div className="inputflexpivot">
          <div className="inputdivs">
            <label className="inplabels">{items[0]}</label>
            <input
              type="text"
              value={Open}
              onChange={(e) => setOpen(e.target.value)}
            ></input>
          </div>
          <div className="inputdivs">
            <label className="inplabels">{items[1]}</label>{" "}
            <input
              type="text"
              value={High}
              onChange={(e) => setHigh(e.target.value)}
            ></input>
          </div>

          <div className="inputdivs">
            <label className="inplabels">{items[2]}</label>{" "}
            <input
              type="text"
              value={Low}
              onChange={(e) => setLow(e.target.value)}
            ></input>
          </div>
          <div className="inputdivs">
            <label className="inplabels">{items[3]}</label>{" "}
            <input
              type="text"
              value={Close}
              onChange={(e) => setClose(e.target.value)}
            ></input>
          </div>
          <button
            onClick={() =>
              calculatePivotPoints(
                parseFloat(High),
                parseFloat(Low),
                parseFloat(Open),
                parseFloat(Close),
                setupdatedStocks
              )
            }
          >
            Calculate
          </button>
        </div>
        <div className="tabelpivot">
          <table className="w-100 pivot-level-table">
            <colgroup>
              <col className="fixed" style={{ width: "12.5%" }} />
              <col style={{ width: "12.5%" }} />
              <col style={{ width: "12.5%" }} />
              <col style={{ width: "12.5%" }} />
              <col style={{ width: "12.5%" }} />
              <col style={{ width: "12.5%" }} />
              <col style={{ width: "12.5%" }} />
              <col style={{ width: "12.5%" }} />
            </colgroup>
            <thead>
              <tr>
                <th className="px-4 py-2 text-start fixed2">Type</th>
                <th className="px-4 py-2 text-center">S3</th>
                <th className="px-4 py-2 text-center">S2</th>
                <th className="px-4 py-2 text-center">S1</th>
                <th className="px-4 py-2 text-center">Pivot points</th>
                <th className="px-4 py-2 text-center">R1</th>
                <th className="px-4 py-2 text-center">R2</th>
                <th className="px-4 py-2 text-center">R3</th>
              </tr>
            </thead>
            <tbody>
              {updatedStocks.pivot_levels?.map((pivotLevel, index) => (
                <tr key={index} className="border-bottom-stock-detail">
                  <td className="px-4 py-2 text-start fixed">
                    {pivotLevel.pivotlevel_name}
                  </td>
                  <td className="px-4 py-2  text-center">
                    {pivotLevel.s3 !== "-" ? pivotLevel.s3.toFixed(2) : "-"}
                  </td>
                  <td className="px-4 py-2  text-center">
                    {pivotLevel.s2 !== "-" ? pivotLevel.s2.toFixed(2) : "-"}
                  </td>
                  <td className="px-4 py-2  text-center">
                    {pivotLevel.s1 !== "-" ? pivotLevel.s1.toFixed(2) : "-"}
                  </td>
                  <td className="px-4 py-2  text-center">
                    {pivotLevel.pp !== "-"
                      ? formatNumberWithCommasAndFontWeight(pivotLevel.pp)
                      : "-"}
                  </td>
                  <td className="px-4 py-2 text-center">
                    {pivotLevel.r1 !== "-" ? pivotLevel.r1.toFixed(2) : "-"}
                  </td>
                  <td className="px-4 py-2  text-center">
                    {pivotLevel.r2 !== "-" ? pivotLevel.r2.toFixed(2) : "-"}
                  </td>
                  <td className="px-4 py-2  text-center">
                    {pivotLevel.r3 !== "-" ? pivotLevel.r3.toFixed(2) : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
